const menuConfig = {
  legal:
    'In addition to the recipe specific allergen information provided, due to production and packing methods Gousto boxes may also contain low levels of the following allergens: cereals containing gluten, crustaceans, eggs, fish, peanuts, soya, milk, nuts (almonds, hazelnuts, walnuts, cashews, pecan nuts, Brazil nuts, pistachio nuts, macadamia nuts), celery, sesame, sulphur dioxide and sulphites, lupin, molluscs, mustard',
  helmet: {
    title: "This Week's Menu | Choose From 150+ Weekly Recipes | Gousto",
    meta: [
      {
        name: 'description',
        content:
          "Explore this week's menu and learn how to cook restaurant grade recipes. Choose from over 500 recipes a month and order your food subscription box today!",
      },
      {
        name: 'keywords',
        content:
          'Gousto, recipe delivery, organic ingredients, fresh, healthy food, cooking, recipe box',
      },
    ],
    style: [
      {
        cssText: `
          body .zopim {
            bottom: 75px !important;
            -webkit-transition: -webkit-filter 0.3s;
            -webkit-filter: blur(0px);
            @media (max-width: 767px) {
              display: none !important;
            }
          }
        `,
      },
    ],
  },
}

// eslint-disable-next-line import/no-default-export
export default menuConfig
